import React, { useState } from "react";
import OptimizedSlider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import news1 from "../../assets/news/news1.jpg";
import news2 from "../../assets/news/news2.jpg";
import news3 from "../../assets/news/news3.jpg";
import news4 from "../../assets/news/news4.jpeg";

import "./NewsCarousel.css";

const items = [
  {
    id: 1,
    image: news1,
    title: "Patricio Poplavsky, el experto de los negocios internacionales que facilita la expansión de empresas latinas en Dubai",
    url: "https://capsulainformativa.cl/patricio-poplavsky-el-experto-de-los-negocios-internacionales-que-facilita-la-expansion-de-empresas-latinas-en-dubai/",
  },
  {
    id: 2,
    image: news2,
    title: "Poplavsky Group: Liderazgo Global en Servicios Corporativos y Legales",
    url: "https://www.perfil.com/noticias/guia-de-profesionales-pnt/poplavsky-group-liderazgo-global-en-servicios-corporativos-y-legales.phtml",
  },
  {
    id: 3,
    image: news3,
    title: "Oportunidades en Dubái: Ventajas, visados y opciones de negocios para los peruanos",
    url: "https://www.peru-retail.com/latinos-en-dubai-a-que-se-dedican-y-cuales-son-las-oportunidades-de-inversion/",
  },
  {
    id: 4,
    image: news4,
    title: "Empresarios argentinos en Dubai: cuántos hay, a qué se dedican y cuál es el rubro que genera más oportunidades de inversión",
    url: "https://economis.com.ar/empresarios-argentinos-en-dubai-cuantos-hay-a-que-se-dedican-y-cual-es-el-rubro-que-genera-mas-oportunidades-de-inversion/",
  },
];

const NewsCarousel = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: "0",
    afterChange: (current) => setActiveIndex(current),
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <OptimizedSlider {...settings} className="news-carousel">
      {items.map((item, index) => (
        <div
          key={item.id}
          className={`news-item ${index === activeIndex ? "active" : "inactive"}`}
        >
          <img src={item.image} alt={item.title} className="news-image" />
          <div className="news-title">
            <a href={item.url} target="_blank" rel="noopener noreferrer" className="news-title-link">
              {item.title}
            </a>
          </div>
        </div>
      ))}
    </OptimizedSlider>
  );
};

export default NewsCarousel;